module.exports = __webpack_public_path__ + "img/Lobby_Banner1.ffde9b19.jpg";